import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Estetica from "@/pages/Estetica";
import Pressoterapia from "@/pages/Pressoterapia";
import Laser from "@/pages/Laser";
import Infrarossi from "@/pages/Infrarossi";
import Radiofrequenza from "@/pages/Radiofrequenza";
import NailArt from "@/pages/NailArt";
import Gelinium from "@/pages/Gelinium";
import Prodotti from "@/pages/Prodotti";
import Contatti from "@/pages/Contatti";
import LegalPage from "@/pages/LegalPage";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="/estetica" element={<Estetica />} />
                    <Route
                        path="/pressoterapia"
                        element={<Pressoterapia />}
                    />
                    <Route path="/laser" element={<Laser />} />
                    <Route path="/infrarossi" element={<Infrarossi />} />
                    <Route
                        path="/radiofrequenza"
                        element={<Radiofrequenza />}
                    />
                    <Route path="/nail-art" element={<NailArt />} />
                    <Route path="/gelinium" element={<Gelinium />} />
                    <Route path="/prodotti" element={<Prodotti />} />
                    <Route path="/contatti" element={<Contatti />} />
                    <Route
                        path="/cookie"
                        element={<LegalPage kind="cookie" />}
                    />
                    <Route
                        path="/privacy"
                        element={<LegalPage kind="privacy" />}
                    />
                    <Route path="*" element={<Home />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
